import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Http, Headers, ConnectionBackend, RequestOptions, Request, Response, RequestOptionsArgs } from "@angular/http";
import { Observable } from "rxjs/Observable";

@Injectable()

export class ActNowHttp extends Http {

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, private router: Router) {
        super(backend, defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        const request = super.request(url, this.getOptions(options));
        return this.intercept(request);
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        const request = super.get(url, this.getOptions(options));
        return this.intercept(request);
    }

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        const request = super.post(url, body, this.getOptions(options));
        return this.intercept(request);
    }

    put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        const request = super.put(url, body, this.getOptions(options));
        return this.intercept(request);
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        const request = super.delete(url, this.getOptions(options));
        return this.intercept(request);
    }

    private getOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
        let mergedOptions: RequestOptionsArgs;

        if (options !== undefined) {
            mergedOptions = options;
        } else {
            mergedOptions = { headers: new Headers() };
        }

        if (mergedOptions.headers === undefined) {
            mergedOptions.headers = new Headers();
        }

        let ctIdx = mergedOptions.headers.keys().indexOf("Content-Type");
        let accIdx = mergedOptions.headers.keys().indexOf("Accept");
        let bypassIdx = mergedOptions.headers.keys().indexOf("BypassContentType");
        let authIdx = mergedOptions.headers.keys().indexOf("Authorization");

        if (ctIdx === -1 && bypassIdx === -1) {
            mergedOptions.headers.append("Content-Type", "application/json");
        }
        if (accIdx === -1) {
            mergedOptions.headers.append("Accept", "application/json;charset=UTF-8");
        }
        if (authIdx === -1) {
            const token = localStorage.getItem("ani-token");
            mergedOptions.headers.append("Authorization", "Bearer " + token);
        }

        return mergedOptions;
    }

    private intercept(obs: Observable<Response>): Observable<Response> {
        return obs.catch((err, src) => {
            if (err.status === 401) {
                this.router.navigate(["/login"]);
            } else {
                return Observable.throw(err);
            }
        });
    }
}




// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/act-now.http.ts